import { useCallback, useContext } from 'react';
import { ErrorContext } from '@/contexts/ErrorContext';
import { ERROR, errorTypes } from '@/helpers/constants';
import useToastContext from './useToastContext';

const CRITICAL_ERRORS = [408, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511];

const useError = () => {
  const { addToast } = useToastContext();
  const context = useContext(ErrorContext);

  if (context === undefined) {
    throw new Error('useError must be used within an ErrorProvider');
  }

  const { setError } = context as any;

  const handleCriticalError = useCallback((err: any, uniqueKey: string = '') => {
    const error = err.toJSON ? err.toJSON() : err;
    console.error(`Error ${error.status}: ${error.code} - ${error.message} - uniqueKey: ${uniqueKey}`); // eslint-disable-line no-console

    if (CRITICAL_ERRORS.includes(error.status)) {
      setError(error);
    } else if (err.name !== errorTypes.ABORT_ERROR) {
      addToast(error.message, ERROR, uniqueKey);
    }
  }, [setError, addToast]);

  return {
    handleCriticalError,
  };
};

export default useError;
